module.exports = __webpack_public_path__ + "static/media/tapir-lightblue.ce695159.png";